import { render, staticRenderFns } from "./tableAndChart.vue?vue&type=template&id=e2239922&scoped=true"
import script from "./tableAndChart.vue?vue&type=script&lang=js"
export * from "./tableAndChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2239922",
  null
  
)

export default component.exports